import React from 'react';
import { Row } from './Flex';
import { Icon } from 'antd';
import InfoItem from './InfoItem';

const SocialIcon = props => {
  return (
    <a
      target="_blank"
      rel="noopener noreferrer"
      href={props.href.includes('http') ? props.href : `http://${props.href}`}
      style={{ marginRight: '6px', marginTop: '4px' }}
    >
      <Icon type={props.type} style={{ fontSize: '24px' }} />
    </a>
  );
};

const SocialIcons = ({ title, p }) => {
  let social = ['facebook', 'twitter', 'instagram', 'linkedin'];
  let socialLinks = social
    .map(x => {
      if (p[x]) {
        return { site: x, link: p[x] };
      }
      return null;
    })
    .filter(x => x !== null);

  let socialIcons = (
    <Row justify="flex-start">
      {p.facebook && <SocialIcon type="facebook" href={p.facebook} />}
      {p.twitter && (
        <SocialIcon type="twitter" href={`https://twitter.com/${p.twitter}`} />
      )}
      {p.instagram && (
        <SocialIcon
          type="instagram"
          href={`https://instagram.com/${p.instagram.replace(/@/g, '')}`}
        />
      )}
      {p.linkedin && <SocialIcon type="linkedin" href={p.linkedin} />}
    </Row>
  );
  if (!socialLinks || socialLinks.length === 0) return null;
  return title ? <InfoItem title={title}>{socialIcons}</InfoItem> : socialIcons;
};
export default SocialIcons;
